import React from "react";
interface Prop {
  id: string;
  title: string;
  data: string;
  setData: React.Dispatch<React.SetStateAction<string>>;
}
const Textarea: React.FC<Prop> = ({data, setData, id, title }) => {
  return (
    <div className="field-textarea">
      <textarea
        className="m-1"
        name={id}
        value={data}
        onChange={(e) => {
          setData(e.target.value);
        }}
        id={id}
        required
      ></textarea>
      <label htmlFor={id} title={title} data-title={id}></label>
    </div>
  );
};

export default Textarea;
